import React, {useEffect, useState} from 'react'
import Kp11GenericCardNumberInput from '../kp-11-generic-cards/kp11-generic-card-number-input'
import {normalizeQuantity} from '../../../../kp-11Link-utility/kp11-utility'

const KP11KeapSocialAdsBronze = ({
  name = 'Social Ads Bronze',
  price,
  isChecked,
  groupKey,
  itemCode,
  onSave,
  quantity,
  disabled,
}) => {
  const normalizedQuantity = String(normalizeQuantity(quantity))
  const [value, setValue] = useState(normalizedQuantity)
  const [isExpanded, setIsExpanded] = useState(isChecked)

  useEffect(() => {
    setValue(String(normalizeQuantity(quantity)))
  }, [quantity])

  useEffect(() => {
    setIsExpanded(isChecked)
  }, [isChecked])

  const handleChange = newValue => {
    setValue(newValue)
  }

  return (
    <Kp11GenericCardNumberInput
      name={name}
      isDisabled={disabled}
      price={price}
      isChecked={isExpanded}
      onClick={() => setIsExpanded(true)}
      label="Number of Campaigns (1-5):"
      value={value}
      onChange={handleChange}
      min={1}
      max={5}
      groupKey={groupKey}
      itemCode={itemCode}
      onSave={finalValue => onSave?.(finalValue)}
      existingquantity={Number(quantity) || 0}
      quantityValidationRequired={true}
    />
  )
}

export {KP11KeapSocialAdsBronze}
